import { useEffect, useRef, useState } from "react";
import SelectRoleNavigation from "../SelectRoleNavigation";
import { useNavigation } from "react-router-dom";

import addButtonSvg from "../../../assets/add-button.svg";
import closeIcon from "../../../assets/close-icon.svg";
import Loader from "../../../components/Loader";
import { API_BASE_URL } from "../../../config";

export default function SalesStepFour({ num, handleDecrement }) {
  const [otherFields, setOtherFields] = useState(false);
  const [newCompanies, setNewCompanies] = useState([]);
  const [idealCompanies, setIdealCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  const ref = useRef();

  useEffect(() => {
    const fetchIdealCompanies = async () => {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/ideal-companies`);

      if (!response.ok) {
        return {
          error: response.message || "Login failed. Please try again.",
        };
      }

      const data = await response.json();
      setIdealCompanies(data.data);
      setIsLoading(false);
    };

    fetchIdealCompanies();
  }, []);

  const handleIdealCompanies = (e) => {
    const value = e.target.name;

    if (value === "other") {
      setOtherFields((prevState) => !prevState);
    }
  };

  const handleNewCompany = () => {
    const value = ref.current.value.trim();
    if (!value) return;

    const name = value.toLowerCase().replace(/\s+/g, "_");

    setNewCompanies((prevState) => [...prevState, { name: name, text: value }]);

    ref.current.value = "";
  };

  const handleDeleteCompany = (copmanyName) => {
    setNewCompanies((prevState) =>
      prevState.filter((company) => company.name !== copmanyName)
    );
  };

  return (
    <>
      <SelectRoleNavigation
        currentStep={num}
        handleDecrement={handleDecrement}
        title="Select ideal companies that you are looking for"
        text="One or multiple selection"
      />
      <div className="container">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="sales-step-last-selection">
            <div className="ideal-companies-wrapper">
              <div className="label-results-wrapper">
                {idealCompanies.map((curr) => (
                  <label key={curr.id}>
                    <input
                      type="checkbox"
                      name="ideal_companies"
                      onChange={handleIdealCompanies}
                      value={curr.id}
                    />
                    <span>{curr.name}</span>
                  </label>
                ))}
                <label>
                  <input
                    type="checkbox"
                    name="other"
                    onChange={handleIdealCompanies}
                  />
                  <span>Other</span>
                </label>
              </div>
            </div>
            {otherFields && (
              <div className="add-new-companies">
                <p>Other</p>
                <div className="add-new-company-wrapper">
                  <input
                    type="text"
                    placeholder="Add new ideal company"
                    ref={ref}
                  />
                  <button type="button" onClick={handleNewCompany}>
                    <img src={addButtonSvg} alt="Add icon" />
                  </button>
                </div>
                {newCompanies.length === 0 ? (
                  <p>Add new one</p>
                ) : (
                  <div className="new-companies-wrapper">
                    {newCompanies.map((curr, index) => (
                      <div className="new-copmany-single" key={index}>
                        <button
                          type="button"
                          onClick={() => handleDeleteCompany(curr.name)}
                        >
                          <img src={closeIcon} alt="close-icon" />
                        </button>
                        <span>{curr.text}</span>
                        <input
                          type="checkbox"
                          name="other_companies"
                          value={curr.text}
                          readOnly
                          checked
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <button className="btn-all-white" type="submit">
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        )}
      </div>
    </>
  );
}
